import { Icon } from "@iconify/react";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminEditDoctorPatient from "./EditDoctorPatient/AdminEditDoctorPatient";

const AdminDoctorPatientTable = ({ patient, onUpdate }) => {
  const [selectedPatient, setSelectedPatient] = useState(null);
  const date = patient?.dateOfBirth ? moment(patient.dateOfBirth).format("DD MMM YYYY") : "—";
  const issueDate = moment().format("YYYY-MM-DD");
  const [packages, setPackages] = useState(null);
  const isExpire = packages?.expireDate
    ? moment(issueDate).isAfter(packages.expireDate)
    : true;

  function closeModal() {
    setSelectedPatient(null);
    if (onUpdate) onUpdate(); // Refresh the parent table lists
  }

  function openModal(patientData) {
    setSelectedPatient(patientData);
  }

  useEffect(() => {
    fetch(
      `https://servercareseebd.careseebd.com/api/v1/package/specific?fieldName=userId&fieldValue=${patient?._id}`
    )
      .then((res) => res.json())
      .then((data) => {
        if (data?.data?.length) {
          setPackages(data.data[0]);
        }
      })
      .catch((err) => console.error("Error fetching package details:", err));
  }, [patient?._id]);

  return (
    <>
      <tr className="hover:bg-slate-50/50 transition-colors duration-150">
        {/* Name */}
        <td className="h-14 px-6 text-sm font-bold text-slate-700">
          {patient.name}
        </td>

        {/* Email */}
        <td className="h-14 px-6 text-xs font-semibold text-slate-500">
          {patient.email}
        </td>

        {/* Phone */}
        <td className="h-14 px-6 text-xs font-semibold">
          <span className="inline-block px-2.5 py-0.5 rounded-full bg-slate-100 text-slate-650 font-bold border border-slate-200">
            {patient.phone || "—"}
          </span>
        </td>

        {/* Date of Birth */}
        <td className="h-14 px-6 text-xs font-semibold text-slate-500">
          {date}
        </td>

        {/* Account Status */}
        <td className="h-14 px-6 text-xs">
          <span
            className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full font-bold text-[10px] tracking-wide uppercase ${patient?.isActive
              ? "bg-green-50 text-green-600"
              : "bg-red-50 text-red-500"
              }`}
          >
            <span
              className={`h-1.5 w-1.5 rounded-full ${patient?.isActive ? "bg-green-600" : "bg-red-500"
                }`}
            ></span>
            {patient?.isActive ? "Active" : "Inactive"}
          </span>
        </td>

        {/* Subscription validity */}
        <td className="h-14 px-6 text-xs">
          <span
            className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full font-bold text-[10px] tracking-wide uppercase ${!isExpire
              ? "bg-green-50 text-green-600"
              : "bg-red-50 text-red-500"
              }`}
          >
            <span
              className={`h-1.5 w-1.5 rounded-full ${!isExpire ? "bg-green-600" : "bg-red-500"
                }`}
            ></span>
            {!isExpire ? "Subscribed" : "Expired"}
          </span>
        </td>

        {/* Actions */}
        <td className="h-14 px-6 text-right">
          <div className="inline-flex items-center gap-2">
            {/* View Patient clinical report details */}
            <Link
              to={`/adminDashboard/doctorsPatientReport/${patient._id}`}
              className="p-1.5 border border-slate-200 text-slate-500 hover:text-secondary hover:border-secondary hover:bg-indigo-50/30 rounded-lg transition duration-150"
              title="View Clinical Reports"
            >
              <Icon icon="solar:graph-bold-duotone" className="text-base" />
            </Link>

            {/* Edit Profile */}
            <button
              onClick={() => openModal(patient)}
              className="p-1.5 border border-slate-200 text-slate-500 hover:text-secondary hover:border-secondary hover:bg-indigo-50/30 rounded-lg transition duration-150 cursor-pointer"
              title="Configure Profile & License"
            >
              <Icon icon="solar:pen-new-square-bold-duotone" className="text-base" />
            </button>
          </div>
        </td>
      </tr>

      {selectedPatient && (
        <AdminEditDoctorPatient
          closeModal={closeModal}
          isOpen={selectedPatient !== null}
          patient={selectedPatient}
        />
      )}
    </>
  );
};

export default AdminDoctorPatientTable;
